export default {
  state: {
    layout: 'loading', // loading, admin, blank
    messages: Object
  },
  getters: {
    getLayout: state => state.layout
  },
  mutations: {
    setLayout (state, payload) {
      state.layout = payload
    },
    setMessages (state, payload) {
      state.messages = payload
    }
  },
  actions: {
    limparMensagens (state) {
      state.commit('setMessages', Object)
    }
  }
}
